<template>
  <div class="condition-multi-select condition-form-item">
    <el-divider />
    <div class="charge-form-label">
      <span>单据包含下述费用类型时：</span>

      <el-button type="primary" icon="el-icon-plus" size="small" @click.prevent="addChargeItem">增加</el-button>
    </div>

    <div v-for="(item, index) in chargeForm" :key="`chargeForm${index}`" class="charge-form-item">
      <p v-if="index" style="margin-right: 20px">或</p>
      <el-select v-model="chargeForm[index]" multiple>
        <el-option
          v-for="item in multiOperations"
          :key="item.id"
          :label="item.itemName"
          :value="item.id"
        />
      </el-select>
      <el-button
        type="danger"
        icon="el-icon-delete"
        size="small"
        :disabled="!canRemove"
        @click.prevent="removeChargeItem(index)"
      >删除</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object
    }
  },

  computed: {
    canRemove() {
      return this.chargeForm.length > 1;
    },

    documentation() {
      return this.chargeForm.map(chargeItem => {
        return {
          conditional: "or",
          selectedValue: chargeItem.map(id => this.findChargeById(id))
        };
      });
    },

    conditionExpression() {
      const expression = this.chargeForm.map(item => {
        return this.getChargeItemExpression(item);
      });
      return `(${expression.join("||")})`;
    }
  },

  data() {
    return {
      chargeForm: [[]],

      multiOperations: [],
      selectedValue: []
    };
  },

  created() {
    this.setChargeTypes();
  },

  methods: {
    setChargeTypes() {
      this.$api.enumTypeCode("cost_type").then(res => {
        this.multiOperations = res;
      });
    },

    addChargeItem() {
      this.chargeForm.push([]);
    },

    removeChargeItem(index) {
      this.chargeForm.splice(index, 1);
    },

    findChargeById(id) {
      return this.multiOperations.find(item => item.id === id);
    },

    getChargeItemExpression(chargeItem) {
      const expression = chargeItem.map(id => `costTypeIds.contains(${id})`);
      return `(${expression.join("&&")})`;
    }
  }
};
</script>

<style scoped lang="scss">
// @import "./common.scss";

.charge-form-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 20px 0;

  .el-button {
    margin: 0 30px 0 0;
  }
}

.charge-form-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 20px 0;

  .el-button {
    margin: 0 30px 0 0;
  }

  .el-select {
    flex: 1;
    margin: 0 20px 0 0;
  }
}
</style>